module.exports = __webpack_public_path__ + "img/coach-tutorial.7373f8ad.png";